import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { DropdownProvider } from "@/contexts/DropdownContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import LoginPage from "@/pages/LoginPage";
import MainLayout from "@/components/layout/MainLayout";
import DashboardPage from "@/pages/DashboardPage";
import LeadsPage from "@/pages/LeadsPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import GanttPage from "@/pages/GanttPage";
import FinancePage from "@/pages/FinancePage";
import TasksPage from "@/pages/TasksPage";
import TeamPage from "@/pages/TeamPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import SettingsPage from "@/pages/SettingsPage";
import QuotationGeneratorPage from "@/pages/QuotationGeneratorPage";
import QuotationEditorPage from "@/pages/QuotationEditorPage";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <DropdownProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/login" element={<LoginPage />} />
                
                <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/leads" element={<LeadsPage />} />
                  <Route path="/projects" element={<ProjectsPage />} />
                  <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
                  <Route path="/projects/:projectId/gantt" element={<GanttPage />} />
                  <Route path="/finance" element={<FinancePage />} />
                  <Route path="/tasks" element={<TasksPage />} />
                  <Route path="/team" element={<TeamPage />} />
                  <Route path="/analytics" element={<AnalyticsPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/quotation-generator" element={<QuotationGeneratorPage />} />
                  <Route path="/quotation-generator/:quotationId" element={<QuotationEditorPage />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster />
          </div>
        </DropdownProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
